// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// Vue.config.devtools = true
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/en'
import router from './router'
// import fastClick from 'fastclick'
import './assets/styles/reset.css'
import './assets/styles/common.css'
import 'styles/iconfont.css'
import './assets/styles/border.css'


//import VueGtm from 'vue-gtm';

Vue.config.productionTip = false
// fastClick.attach(document.body)
Vue.use(ElementUI)


// Vue.use(VueGtm, {
//   id: 'GTM-WSTZFR3',
//   debug:true,
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  render: h => h(App),
  template: '<div class="parentDiv"><App/></div>'
})



// WEBPACK FOOTER //
// ./src/main.js